<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <!-- <router-link to="/manage">SKU管理</router-link>
      <span class="arrow"><i class="iconfont icon-arrow"></i></span>
      <span>商品管理</span> -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>知识付费内容管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <div @click="handleGo('', 'kBaseinfo')">
            <p class="flex-rowl"><i class="iconfont icon-xinzeng"></i> 新增</p>
          </div>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="关键词查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示知识付费列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.cover" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      内容所属系列：<span>{{ item.typeidstr }}</span>
                    </p>
                    <p>
                      序号：<span>{{ item.klno }}</span>
                    </p>
                    <p>
                      所属企业：<span>{{ item.qyguidstr }}</span>
                    </p>
                    <p>
                      内容标签：<span>{{ item.topic }}</span>
                    </p>
                    <p>
                      属性：<span>{{ item.attrvalstr }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      内容收费价格：<span>{{ item.price }}</span>
                    </p>
                    <p>
                      是否启用：<span>{{ item.isuse }}</span>
                    </p>
                    <p>
                      发布时间：<span>{{ item.publishdate | formatDate }}</span>
                    </p>
                    <p>
                      创建者：<span>{{ item.creater }}</span>
                    </p>
                  </div>
                </div>
                <div class="operation_box flex-colt">
                  <a href="javascript:;" @click="handleGo(item.id, 'kBaseinfo')"
                    >基础信息设置</a
                  >
                  <a href="javascript:;" @click="handleGo(item.id, 'kDetail')"
                    >内容详情</a
                  >
                  <a href="javascript:;" @click="handleGo(item.id, 'kVideoList')"
                    >内容视频链接</a
                  >
                  <a href="javascript:;" @click="handleGo(item.id, 'kBuyadd')"
                    >用户购买记录</a
                  >
                  <a
                    href="javascript:;"
                    @click="handleGo(item.id, 'kVisitlist')"
                    >用户观看记录</a
                  >
                </div>
              </div>
            </div>
            <div class="shop_more"></div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!-- 弹窗内容展示 start -->
    <div class="custom_dialog" v-show="isShow">
      <div class="custom_wrap">
        <div class="custom_diaog_body">
          <div class="ercode">
            <el-image style="height: 430px" :src="shopPopupImg"></el-image>
          </div>
          <div class="download">
            <a :href="shopPopupImg" target="_blank" download="image.png"
              >下载图片</a
            >
          </div>
        </div>
        <div class="close" @click="isShow = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </div>
    <!-- 弹窗内容展示 end -->
  </div>
</template>

<script>
import { getMenuAuthTwo, encryptstringadd } from "../../api/api";
import { getKonwledgeList } from "../../api/knowledge";
// import { getShopErcodeImg } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "kManageIndex",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      isShow: false,
      loading: false,
      listTotal: 0,
      dataList: [],
      params: {
        qyguid: "",
        pageindex: 1,
        pagesize: 10,
        keyword: "",
      },

      dataItem: "", // 单个商品
      shopPopupImg: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.params.qyguid = userInfo.qy.qyguid;
    this.roleId = userInfo.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
    this.initData();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.initData();
    },
    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },
    // 重置
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.initData();
    },
    initData() {
      let { params } = this;
      this.loading = true;
      getKonwledgeList(params).then((res) => {
        this.listTotal = res.total;
        // this.dataList = res.list.concat(...this.dataList);
        this.dataList = res.list;
        this.loading = false;
        // this.dataList = this.dataList.concat(...res.list);
      });
    },

    handleGo(id, name) {
      this.encryptstringadd(name, { id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          // this.$router.push({
          //   name,
          //   params,
          // })
          window.open(this.$router.resolve({ name, params }).href, "_blank");
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .main_container {
    .screen_wrap {
      font-size: 14px;
      margin-right: 30px;
      .txt {
        cursor: pointer;
        &.active {
          font-size: 16px;
          color: red;
        }
        &:nth-child(2) {
          margin: 0 20px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .ercode {
      margin-top: 10px;
      cursor: pointer;
    }
  }
  .custom_dialog {
    .custom_wrap {
      width: 500px;
      height: 500px;
      .custom_diaog_body {
        height: 100%;
        box-sizing: border-box;
        // padding-top: 50px;
        .ercode {
          text-align: center;
          // margin-bottom: 32px;
        }
        .txt {
          p {
            text-align: center;
            font-size: 20px;
            color: #000000;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 30px;
            }
          }
        }
        .download {
          text-align: center;
          a {
            font-size: 18px;
            color: #0006ff;
            border-bottom: 1px solid #0006ff;
            padding-bottom: 5px;
          }
        }
      }
      .close {
        position: absolute;
        left: 50%;
        color: #fff;
        bottom: -50px;
        transform: translateX(-50%);
        cursor: pointer;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
}
</style>